// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"cff034df","58":"0b4c4d14","173":"0b4c4d14","253":"0fead087","346":"bf5acf15","347":"359144ed","545":"4b65700f","558":"0b4c4d14","982":"93e620a5"}[chunkId] + ".chunk.css";
};